import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd2be30e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "position-fixed vw-100 bottom-0 end-0 unclickable"
}

import { computed } from 'vue';
import store from '@app/store';
import UndoDeleteToast from '@app/components/generic/undoDeleteToast.vue';
import ErrorMessageToast from '@app/components/generic/errorMessageToast.vue';
import SuccessMessageToast from '@app/components/generic/successMessageToast.vue';
import ExportProgressToast from '@app/components/generic/exportProgressToast.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'toasts',
  setup(__props) {

const toasts = computed(() => store.state.toasts);

const teleportTarget = computed(() => {
  // If there is a modal open, we need to move the toasts inside the dialog element so that they appear on top.
  const topModalId = store.state.openModals[store.state.openModals.length - 1];
  return topModalId ? `#modal-toast-container-${topModalId}` : 'body';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: teleportTarget.value }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: toast.key
        }, [
          (toast.componentName === 'UndoDeleteToast')
            ? (_openBlock(), _createBlock(UndoDeleteToast, {
                key: 0,
                message: toast.message,
                "undo-delete": toast.undoDelete
              }, null, 8 /* PROPS */, ["message", "undo-delete"]))
            : _createCommentVNode("v-if", true),
          (toast.componentName === 'ErrorMessageToast')
            ? (_openBlock(), _createBlock(ErrorMessageToast, {
                key: 1,
                message: toast.message
              }, null, 8 /* PROPS */, ["message"]))
            : _createCommentVNode("v-if", true),
          (toast.componentName === 'SuccessMessageToast')
            ? (_openBlock(), _createBlock(SuccessMessageToast, {
                key: 2,
                message: toast.message
              }, null, 8 /* PROPS */, ["message"]))
            : _createCommentVNode("v-if", true),
          (toast.componentName === 'ExportProgressToast')
            ? (_openBlock(), _createBlock(ExportProgressToast, {
                key: 3,
                message: toast.message
              }, null, 8 /* PROPS */, ["message"]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 8 /* PROPS */, ["to"]))
}
}

})